
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fashion-week-web",
      function () {
        return require("private-next-pages/fashion-week-web.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fashion-week-web"])
      });
    }
  